import { currentYear } from '@fnol/library/src/lib';

export const translations = {
    stepLabel: {
        START: 'Početak',
        SUBMITTER: 'Podnosilac',
        DETAILS: 'Detalji',
        VEHICLE: 'Vozilo ili objekat',
        PERSONS: 'Lica',
        DOCUMENTATION: 'Dokumentacija',
        CONFIRMATION: 'Potvrda',
        INTRO_START: 'Početak',
        INTRO_DOCUMENTATION: 'Dokumentacija',
        INTRO_CONFIRMATION: 'Saglasnost',
    },
    intro: {
        INTRO_MESSAGE_1_TITLE: 'KAKO DA PRIJAVITE ŠTETU ONLAJN',
        INTRO_MESSAGE_1_LINE_1: 'Pripremite obavezna dokumenta navedena na sledećoj stranici',
        INTRO_MESSAGE_1_LINE_2: 'Popunite onlajn prijavu',
        INTRO_MESSAGE_1_LINE_3:
            'Odmah po slanju prijave, dobićete potvrdu za svaki odštetni zahtev posebno putem imejla',
        INTRO_MESSAGE_1_LINE_4: 'Na istu imejl adresu stizaće vam sva obaveštenja i odluke o prijavi',
        INTRO_MESSAGE_1_LINE_5_1: 'Status i ishode možete da pratite ',
        // INTRO_MESSAGE_1_LINE_5_LINK_1: 'https://www.generali.rs/portal_za_klijente_.3646.html',
        // INTRO_MESSAGE_1_LINE_5_2: 'Portalu za klijente',
        // INTRO_MESSAGE_1_LINE_5_3: ' (fizička lica) ili ',
        INTRO_MESSAGE_1_LINE_5_LINK_2:
            'https://www.generali.rs/fizicka_lica/prijava_i_status_stete__naknade/provera_statusa_stetenaknade.1249.html',
        INTRO_MESSAGE_1_LINE_5_2: 'ovde',
        INTRO_MESSAGE_1_REMARK:
            'Napomena: Zahtev za nadoknadu podnosi oštećena strana u osiguravajućoj kući krivca za nezgodu.',

        INTRO_MESSAGE_2_TITLE: 'OBAVEZNA DOKUMENTACIJA',
        INTRO_MESSAGE_2_INTRO: 'Pripremite sledeću dokumentaciju:',
        INTRO_MESSAGE_2_LINE_1: 'Evropski izveštaj o saobraćajnoj nezgodi (ukoliko je popunjen sa drugim učesnikom)',
        INTRO_MESSAGE_2_LINE_2:
            'Saobraćajnu dozvolu - kopija obe strane ili očitana (u slučaju štete na motornom vozilu)',
        INTRO_MESSAGE_2_LINE_3: 'Kopija kartice tekućeg računa (ukoliko u prijavi izaberete uplatu na tekući račun)',
        INTRO_MESSAGE_2_REMARK:
            'Skenirana dokumenta, fotografije i druge priloge možete poslati odmah putem onlajn prijave (korak „Dokumentacija“) ili naknadno, imejlom na adresu navedenu u imejlu o potvrdi prijave.',
    },
    legalPersonType: {
        INDIVIDUAL: 'Fizičko lice',
        LEGAL: 'Pravno lice',
    },
    SUBMITTER: 'Podnosilac',
    SELECT_REQUEST_TYPE: `${
        window.innerWidth > 767 ? 'Izaberite vrstu zahteva koji želite da prijavite' : 'Izaberite vrstu zahteva'
    }`,
    SELECT_LEGAL_PERSON_ROLE_TYPE: 'Svojstvo podnosioca u odnosu na lice',
    REQUEST_TYPE: 'Vrsta zahteva',
    CHOOSE_SUBMITTER_TYPE: 'Želim da prijavim zahtev kao:',
    DATE: 'Datum *',
    HOUR: 'Sat *',
    MINUTE: 'Minut *',
    TIME_OF_OCCURANCE: 'Vreme nastanka',
    OTHER_INDUSTRIAL_CLASSIFICATIONS: 'Ostale delatnosti',
    claimDetail: {
        PLACE_OF_OCCURANCE: 'Mesto nastanka',
        CIRCUMSTANCES_OF_DAMAGE: 'Okolnosti nastanka',
        CITY: 'Mesto',
        STREET: 'U ulici - na relaciji',
        EU_TRAFFIC_ACCIDENT: 'Da li je popunjavan evropski izveštaj o saobraćajnoj nezgodi? *',
        WAS_POLICE_NOTIFIED: 'Da li je događaj prijavljen policiji? *',
        POLICE_ON_SCENE: 'Da li je policija izašla na lice mesta? *',
        POLICE_INVESTIGATION: 'Da li je policija obavila uviđaj saobraćajne nezgode? *',
        DESCRIBE_EVENT: `${
            window.innerWidth > 767 ? 'Ukratko opišite kako je došlo do štetnog događaja *' : 'Opišite događaj *'
        }`,
    },
    vehicleOwner: {
        VEHICLE_OWNER: 'Vlasnik vozila',
        DO_YOU_OWN_VEHICLE: 'Da li ste Vi vlasnik vozila u saobraćajnoj dozvoli? *',
        APLICANT_OWNER_OF_VEHICLE: 'Da li je podnosilac',
        APLICANT2: 'vlasnik vozila u saobraćajnoj dozvoli? *',
        OWNER_LEGAL_OR_PERSONAL_ENTITY: 'Da li je vlasnik vozila pravno ili fizičko lice? *',
        CONNECTIONS_WITH_OWNER: 'Vaše svojstvo u odnosu na vlasnika*',
        OWNER_IS: 'Vlasnik je*',
        INDIVIDUAL: 'fizičko lice',
        LEGAL: 'pravno lice',
    },
    vehicleUser: {
        VEHICLE_USER: 'Korisnik vozila',
        VEHICLE_USED_BY:
            'Da li se vozilo koristi po osnovu ovlašćenja, ugovora o korišćenju ili je korisnik naveden u saobraćajnoj dozvoli?*',
        ARE_YOU_USER: 'Da li ste Vi korisnik vozila (u saobraćajnoj dozvoli)?*',
        LEGAL: 'Da li je podnosilac',
        LEGAL2: 'korisnik vozila u saobraćajnoj dozvoli?* ',
        USER_IS: 'Korisnik vozila je*',
    },
    driver: {
        DRIVER: 'Vozač',
        IS_VEHICLE_PARKED: 'Da li je ovo vozilo u vreme nastanka nezgode bilo parkirano? *',
        PICK_DRIVER: 'Izaberite vozača *',
    },
    sectionDamageVehicle: {
        DAMAGE_DATA: 'Podaci o šteti',
        IS_VEHICLE_DRIVABLE: 'Da li je vozilo pokretno (u voznom stanju)? * ',
        VEHICLE_LOCATION: 'Gde se nalazi vozilo? (mesto i adresa)',
        DAMAGE_DESCRIPTION: 'Ukratko opišite oštećenja*',
        OTHER_DAMAGE: 'Navedite ako je još nešto oštećeno',
        SERVICE: 'Servis za popravku vozila',
        SERVICE_NAME_AND_LOCATION: `${
            window.innerWidth > 767
                ? 'Naziv i mesto servisa gde nameravate da popravite vozilo'
                : 'Naziv i mesto servisa'
        }`,
        PAYMENT: 'Plaćanje',
        WHO_SHOULD_WE_PAY: 'Kome da platimo štetu na vozilu?',
        DAMAGE_PHOTOS: 'Snimanje oštećenja',
        SMS_LINK: 'Da li želite da pošaljemo SMS sa linkom za samostalno snimanje štete? *',
        WHO_SHOULD_WE_SEND_LINK: 'Kom licu da pošaljemo link? *',
        PHONE_NUM_WE_SEND_LINK: 'Na koji broj telefona da pošaljemo link? *',
        OTHER_DAMAGES_TOOLTIP:
            'npr. prtljag u vozilu, zaštitna oprema (moticiklistička kaciga, jakna, rukavice i sl.), odeća, troškovi prevoza vozila i sl.“.',
    },
    objectOwner: {
        OBJECT_OWNER: 'Vlasnik objekta',
        DO_YOU_OWN_OBJECT: 'Da li ste Vi vlasnik objekta?',
        APPLICANT_OWNER_OF_OBJECT: 'Da li je podnosilac ',
        APPLICANT2: ' vlasnik objekta?',
        OWNER_LEGAL_OR_PERSONAL_ENTITY: 'Vlasnik je ',
    },
    personalInfo: {
        CLAIM_SUBMITTED_BY: 'Zahtev podnosi',
        NAME: 'Ime',
        LAST_NAME: 'Prezime',
        UCN: 'JMBG',
        ADDRESS: 'Adresa',
        CITY: 'Mesto',
        MOBILE: 'Mobilni telefon',
        MOBILE_STAR: 'Mobilni telefon *',
        EMAIL: 'E-mail',
        REPORTING_IMMATERIAL_DAMAGE_OR_BODILY_HARM:
            'Da li za lice podnosite zahtev za povrede i/ili nematerijalne posledice nezgode?',
        LINK_RECEPIENT: 'Na koji broj telefona da pošaljemo link? *',
        DID_YOU_DRIVE: 'Da li ste vi upravljali vozilom? *',
        SUBMITTER_RELATION: 'Vaše svojstvo u odnosu na lice',
        PERSON_ROLE: `${
            window.innerWidth > 767 ? 'Svojstvo učesnika u saobraćajnoj nezgodi' : 'Svojstvo učesnika u nezgodi'
        }`,
    },
    legalInfo: {
        PERSON: 'Pravno lice ili preduzetnik',
        CONTACT_INFO: 'Vaši kontakt podaci',
        SUBMITTER_LEGAL_NAME: 'Poslovno ime',
        ID: 'Matični broj',
        VAT: 'PIB',
        EMAIL: 'E-mail',
        NAME: 'Ime',
        LAST_NAME: 'Prezime',
        MOBILE: 'Mobilni telefon *',
        CONTACT_EMAIL: 'E-mail',
        LEASING: 'Lizing kuća *',
    },
    NO_INJURED_DRIVER_REQUEST:
        'Ne možete da podnesete zahtev za povrede i/ili nematerijalne posledice nezgode vozača po sopstvenoj polisi autoodgovornosti.',
    VEHICLE_TO_BLAME: 'Vozilo koje je izazvalo saobraćajnu nezgodu',
    POLICY_OR_REGISTRATION_NUMBER: 'Broj polise ili registarska oznaka',
    validationMessages: {
        REQUIRED_FIELD: 'Obavezno polje',
        POLICY_OR_REGISTRATION_NUMBER_REQUIRED: 'Molimo Vas da unesete broj polise ili registarski broj vozila',
        POLICY_OR_REGISTRATION_NUMBER_INVALID_FORMAT:
            'Molimo Vas da unesete broj polise ili registarski broj u odgovarajućem formatu',
        REGISTRATION_NUMBER_REQUIRED: 'Molimo Vas da unesete registarski broj vozila',
        REGISTRATION_NUMBER_INVALID_FORMAT: 'Molimo Vas da unesete registarski broj u odgovarajućem formatu',
        PHONE_NUMBER_FORMAT: 'Potrebno je uneti broj telefona u odgovarajućem formatu (+xxxxxxxxxx)',
        PHONE_NUMBER_FORMAT_SERBIAN:
            'Morate da unesete broj telefona mobilnog operatera iz Srbije (u obliku +3816xxxxxx)',
        EMAIL_ADDRESS_FORMAT: 'Potrebno je uneti e-mail adresu u odgovarajućem formatu (xx@xx.xx)',
        VAT_NUMBER_INVALID_FORMAT: 'Molimo Vas da unesete PIB u odgovarajućem formatu (samo brojevi)',
        LEGAL_ENTITY_NUMBER_INVALID_FORMAT: 'Matični broj nije u ispravnom formatu. Proverite podatke.',
        VAT_INVALID_FORMAT: 'Uneti PIB nije u ispravnom formatu. Proverite podatke.',
        PRODUCTION_YEAR_INVALID_FORMAT: 'Godinu proizvodnje morate da unesete u formatu GGGG.',
        INVALID_YEAR: `Godina mora biti u opsegu od 1800. do ${currentYear}.`,
        CHASSIS_NUMBER_INVALID: 'Broj šasije nije u odgovarajućem formatu.',
        CANNOT_USE_POLICY:
            'Ne možete da prijavite štetu na vozilu po polisi od autoodgovornosti kojom je to vozilo osigurano.',
        CANNOT_USE_POLICY_BY_CAR:
            'Ne možete da prijavite štetu na vozilu po polisi od autoodgovornosti kojom je to vozilo osigurano. Ako želite da nastavite sa prijavom za lica, vratite se na korak 2. "Podnosilac" i promenite vrstu zahtava u "Telesne povrede ili zahtev za naknadu nematerijalnih posledica nezgode".',
        UCN_INVALID_FORMAT: 'JMBG nije u odgovarajućem formatu!',
        ALREADY_HAS_IMMATERIAL: 'Ne možete ponovo dodati isto lice.',
        CLAIM_ALREADY_EXISTS_FOR_UCN:
            'Za ovo lice već postoji podnet zahtev za vlastite povrede i/ili nematerijalne posledice nezgode. Ukoliko želite da prijavite zahtev za drugo lice, nastavite sa prijavom.',
        CLAIM_ALREADY_EXISTS_FOR_CHASSIS_NUMBER_MATERIAL:
            'Za vozilo sa unetim brojem šasije i datumom nezgode već postoji prijavljen zahtev.',
        CLAIM_ALREADY_EXISTS_FOR_CHASSIS_NUMBER_IMMATERIAL:
            'Za vozilo sa unetim brojem šasije i datumom nezgode već postoji prijavljen zahtev. Izaberite DALJE, ako želite da prijavite zahtev/-e za telesne povrede ili za naknadu nematerijalnih posledica nezgode.',
        CONTACT_REQUIRED: 'Obavezno je uneti jedan kontakt podatak (email ili mobilni telefon)',
    },
    // leasing: {
    //     VEHICLE_LEASED: 'Da li je vozilo predmet ugovora o lizingu?*',
    // },
    COUNTRY: 'Država *',
    STREET: 'Adresa *',
    CITY: 'Mesto *',
    CHOOSE_DAMAGE_TYPE: 'Šta je oštećeno?',
    vehicle: {
        TYPE: 'Vrsta *',
        CHASSIS_NUMBER: 'Broj šasije',
        BRAND: 'Marka',
        MODEL: 'Tip',
        REGISTRATION: 'Registarska oznaka',
        PRODUCTION_YEAR: 'Godina proizvodnje',
    },
    documentation: {
        ADD_DOC: 'Dodajte dokumenta u odgovarajuće kategorije',
        CHOOSE_DOC: 'odaberi dokument',
        TOTAL_UPLOAD_SIZE_LABEL: 'Ukupna veličina priloga koju možete poslati je ',
        TOTAL_UPLOAD_SIZE_LEFT_LABEL: 'Preostala veličina priloga koju možete poslati je ',
        DOCUMENTATION_MB_SPACE: ' MB.',
        ALLOWED_FILE_FORMATS: 'Dozvoljeni formati su: ',
        LOADING_MESSAGE: 'Podaci se prosleđuju. Molimo sačekajte.',
        COMPRESS_MESSAGE: 'Fajlovi se kompresuju. Molimo sačekajte.',
    },
    object: {
        TYPE: 'Vrsta',
        DESCRIPTION: 'Opis',
        CONSTRUCTION_YEAR: 'Godina gradnje/proizvodnje',
        LOCATION: 'Mesto i adresa gde se nalazi oštećeni objekat?',
        DAMAGE_DESCRIPTION: 'Ukratko opišite oštećenja *',
        MORE_DAMAGES: 'Navedite ako je još nešto oštećeno',
    },
    INJURED_PERSONS_TITLE: 'Lica za koja podnosite zahtev za povrede i/ili nematerijalne posledice nezgode',
    INJURED_PERSONS_ADD_NEW_PERSON: 'DODAJTE NOVO LICE',
    INJURED_PERSONS_SAVE: 'SAČUVAJ',
    INJURED_PERSONS_CANCEL: 'ODUSTANI',
    CONFIRM_DELETE: 'Da li ste sigurni da želite da poništite prijavu za ovo lice?',
    tooltips: {
        POLICY_NUMBER_TOOLTIP:
            'Broj polise sadrži minimalno 8 cifara. Unositi bez početne dve cifre "15" (oznaka društva za osiguranje).',
        REGISTRATION_NUMBER_TOOLTIP:
            'Broj registarske oznake (slova i cifre) unosite bez razmaka i specijalnih karaktera.',
        CHASSIS_NUMBER_TOOLTIP: 'Broj šasije treba uneti u sledecem formatu:',
        CHASSIS_NUMBER_TOOLTIP_1: '1) 17 karaktera (samo slova i brojevi) bez slova slova I, O i Q',
        CHASSIS_NUMBER_TOOLTIP_2: '2) slova “PUS“ na početku broja šasije + 5 ili više cifara',
        CHASSIS_NUMBER: 'Broj šasije ne sadrži slova I, O i Q.',
        DAMAGE_TYPE_OTHER: 'Građevinski objekti (kuća, lokal, rampa, zgrada), bicikl, trotinet, ili sl.',
        PHONE_TOOLTIP: 'Morate da unesete broj telefona operatera iz Srbije',
    },
    SELECT_INDUSTRIAL_TYPE: 'Delatnost *',
    confirmationScreen: {
        BASIC_INFORMATION: 'Osnovni podaci',
        POLICY_NUMBER: 'Broj polise',
        OPENED_REQUESTS: 'Po slanju podataka otvorićemo sledeće posebne zahteve:',
        REQUEST: 'Zahtev',
        DESCRIPTION: 'Opis',
        VEHICLE_DAMAGE: 'Šteta na vozilu',
        OBJECT_DAMAGE: 'Šteta na objektu ili predmetu',
        INJURIES: 'Povrede i/ili nematerijalne posledice nezgode',
        AGREEMENT:
            'Saglasan/-na sam da Generali Osiguranje Srbija a.d.o. sa mnom kontaktira, šalje mi korisne informacije, ponude i obaveštenja o proizvodima i uslugama osiguranja.',
        PRIVACY: 'Više o načinu na koji upravljamo vašim podacima možete pročitati u našoj ',
        PRIVACY_POLICY_LINK: 'Politici privatnosti',
        PRIVACY_POLICY_URL: 'https://www.generali.rs/footer.1056.html',
        ENSUREE:
            'Osiguravač nije u obavezi da pruži osiguravajuće pokriće niti da plati bilo kakav odštetni zahtev ili isplati bilo kakvu naknadu na osnovu ugovora o osiguranju u onoj meri u kojoj bi ga pružanje takvog pokrića, plaćanje takvog odštetnog zahteva ili omogućavanje takve naknade izložilo bilo kakvoj sankciji, zabrani ili ograničenju na osnovu rezolucija Ujedinjenih nacija ili trgovinskih ili ekonomskih sankcija, zakona ili propisa Evropske unije, Sjedinjenih Američkih država ili Republike Srbije.',
        WRONG_PASS: 'Lozinka je neispravna ili je istekla. Proverite i pokušajte ponovo.',
        CLAIM_ERROR: 'Šteta nije snimljena. Pokušajte ponovo.',
    },
    userNotification: {
        CONFIRMATION_OF_APPLICANT: 'Potvrda podnosioca zahteva',
        RECIEVE_MESSAGE: 'Odaberite način za prijem jednokratne lozinke',
        SMS: 'SMS',
        EMAIL: 'Imejl',
        MSG_SENT: 'Poslali smo vam poruku/imejl',
        ONE_TIME_PASS: 'Jednokratna lozinka *',
        ERROR: 'Ne postoje podaci za unete kontakt podatke i privremenu lozinku!',
    },
    requestType: {
        VEHICLE: 'Šteta na vozilu ili objektu',
        IMMATERIAL: 'Telesne povrede ili zahtev za naknadu nematerijalnih posledica nezgode',
        BOTH: 'Šteta na vozilu ili objektu i telesne povrede ili zahtev za naknadu nematerijalnih posledica nezgode',
    },
    success: {
        SUCCESS_SINGLE_1: 'Uspešno ste prijavili zahtev.',
        SUCCESS_SINGLE_2: 'Potvrdu prijave poslali smo Vam na imejl.',
        SUCCESS_MULTIPLE_1: 'Uspešno ste prijavili zahteve.',
        SUCCESS_MULTIPLE_2: 'Potvrde prijava poslali smo Vam posebno za svaki zahtev na imejl.',
        CLAIM_NUMBER: '',
        NOTIFICATION_SEND: '',
        TYPE: 'Vrsta',
        DESCRIPTION: 'Opis',
        REQUEST_NUMBER: 'Broj zahteva',
    },
    IMMATERIAL_DAMAGE_DESCRIPTION: `${
        window.innerWidth > 767 ? 'Napomena za povrede i/ili posledice nezgode' : 'Napomena o povredama'
    }`,
    PERSON: 'Lice',
    ROLE: 'Svojstvo',
    REMAINING_CHARACTERS: 'Preostalo karaktera:',
    ADD_CONTACT: 'Unesite drugi kontakt',
    INJURED_PERSONS_REQUIRED:
        'Potrebno je da unesete podatke o barem jednoj povređenoj osobi za izabranu vrstu zahteva.',
};

export enum requestType {
    MaterialDamage = 1,
    ImmaterialDamage = 2,
    Both = 3,
}

export const requestTypeOptions = [
    {
        id: requestType.MaterialDamage,
        value: 'Šteta na vozilu ili objektu',
    },
    {
        id: requestType.ImmaterialDamage,
        value: 'Telesne povrede ili zahtev za naknadu nematerijalnih posledica nezgode',
    },
    {
        id: requestType.Both,
        value: 'Obe vrste zahteva',
    },
];

export enum bodyHarm {
    InitialValue = 1,
    CanBeSubmitted = 2,
    AlreadySubmitted = 3,
}

export class constValues {
    static readonly countrySerbiaId: number = 197;
    static readonly dialCodeSerbia: string = '+381';
    static readonly industrialClassificationTypeLeasing: string = '6491';
    static readonly driver: number = 1;
    static readonly legalRepresentative: number = 1;
    static readonly relationToPersonOther: number = 3;
}

export enum personType {
    initialValue = 0,
    submitter = 1,
    owner = 2,
    user = 3,
    driver = 4,
    injured = 5,
    ownerBuilding = 6,
}

export enum legalPersonType {
    initialValue = '0',
    individual = '1',
    legal = '2',
}

export enum damageType {
    vehicle = 'Vozilo',
    other = 'Objekat ili drugo',
}

export enum driverSelection {
    initialValue = 0,
    submitter = 1,
    owner = 2,
    user = 3,
    other = 4,
}

export const acceptedUploadFileTypesArray = ['pdf', 'jpg', 'jpeg', 'png', 'doc', 'docx', 'rtf', 'xls', 'xlsx', 'txt'];

export const question255MaxLength = 255;
export const question150MaxLength = 150;
export const questionMaxLength = 100;
export const question50MaxLength = 50;
export const question30MaxLength = 30;
export const question25MaxLength = 25;
export const question20MaxLength = 20;
export const question15MaxLength = 15;

export const nameMaxLength = 20;
export const surnameMaxLength = 30;
export const ucnMaxLength = 13;
export const chasisMaxLength = 17;
export const chasisFreeMaxLength = 25;
export const phoneMaxLength = 15;
